import { render, staticRenderFns } from "./Alertas.vue?vue&type=template&id=aacd5cae&scoped=true"
import script from "./Alertas.vue?vue&type=script&lang=js"
export * from "./Alertas.vue?vue&type=script&lang=js"
import style0 from "./Alertas.vue?vue&type=style&index=0&id=aacd5cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacd5cae",
  null
  
)

export default component.exports